import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import { updateIndicator } from 'app/redux/store/features/configs'
import { getMemberById } from 'app/redux/store/features/members'
import UpdateMemberForm from './UpdateMemberForm'

/** Stable placeholder so useSelector !== new {} every dispatch (would retrigger form effects infinitely). */
const MEMBER_ROW_NOT_READY = {}

const UpdateMember = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { state } = useLocation()
    const { familyId, memberId } = state
    const { loading: memberLoading, error: memberError } = useSelector((state) => state.members)
    const { loading: familyLoading, error: familyError } = useSelector((state) => state.families)
    const member = useSelector((state) => {
        const row = state.members.members.data.find(
            (m) => m.id === memberId || String(m.id) === String(memberId)
        )
        return row ?? MEMBER_ROW_NOT_READY
    })

    useEffect(() => {
        if (utilServices.isNullOrUndefined(member.id)) {
            dispatch(getMemberById({ familyId: familyId, id: memberId }))
        }
    }, [dispatch, familyId, member.id, memberId])

    useEffect(() => {
        if (!apiCallInProgress || memberLoading || familyLoading) return
        setApiCallInProgress(false)

        if (memberError) handleError(memberError)
        else if (familyError) handleError(familyError)
        else {
            enqueueSnackbar('Member updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            dispatch(updateIndicator({ inProgress: false }))
            navigate('/registrations/families')
        }
    }, [memberLoading, familyLoading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    return (
        <React.Fragment>
            <UpdateMemberForm memberData={member} setApiCallInProgress={setApiCallInProgress} />
        </React.Fragment>
    )
}

export default UpdateMember
